import React, { useEffect, useState } from "react";
import { Card, Button } from 'antd';
import ReactEcharts from 'echarts-for-react';
import { YhBox } from "@/components/YhBox";

import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { homeService } from "./homeService.ts"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function Pie() {
    const [options, setOptions] = useState([])
    let LanguageArr = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    useEffect(() => {
        homeService.today().then(res => {
            let { retData } = res
            let resObj = retData[0]
            let newOptions = Object.keys(resObj).map((item) => {
                return item = {
                    // value: `${resObj[item].amount}/${resObj[item].num}`,
                    value: resObj[item].num,
                    name: `${language == "zh-CN" ? resObj[item].name : resObj[item].nameEn}/${resObj[item].amount}`,
                }
            })
            setOptions(newOptions)
        })

    }, [language])
    const nameObj = {
        "turnover": "营业额",
        "maintenanceAmount": "维修额",
        "salesAmount": "销售额",
        "warehousingAmount": "入库额",
        "deliveryAmount": "出库额"
    }
    const option = {
        title: {
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            right: 'right',
            top: "15%",
            // data: ['进厂量','预约量','回访量','销售量','失约量']

        },
        series: [
            {
                name: '访问来源',
                type: 'pie',
                radius: '70%',
                data: options,
                // data: [
                //     { value: 1048, name: '营业额' },
                //     { value: 735, name: '维修额' },
                //     { value: 580, name: '销售额' },
                //     { value: 484, name: '入库额' },
                //     { value: 300, name: '出库额' }
                // ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    const rightChildren = <Button
        className="mr-5"
        type="link"
        shape="round"
    // onClick={() => addNav("3-2")}
    >{Locale["day"]}</Button>
    return (
        <YhBox
            title={<></>}
            style={{ height: "50%", marginBottom: "15px" }}
            rightChildren={rightChildren}
        >
            <ReactEchartsCore
                echarts={echarts}
                theme="light"
                option={option}
            // style={{ height: '100vh' }}
            />
        </YhBox>
    )
}